<template>
  <div class="tgh-booking tgh-page">
    <TitlePage title="BOOKING" :desc="summary"></TitlePage>
    <div class="tgh-booking-box">
      <div class="row no-gutters">
        <div class="col col-6 col-md-6">
          <a :href="dailybook" target="_blank" class="tgh-booking-btn tgh-booking-daily">
          <h1>DAILY</h1>
          </a>
        </div>
        <div class="col col-6 col-md-6">
          <h1 @click="toglBook()" class="tgh-booking-btn tgh-booking-long-term">LONG TERM</h1>
        </div>
      </div>
    </div>
    <transition name="custom-classes-transition"
    enter-active-class="animated flipInX"
    leave-active-class="animated flipOutX">
      <div class="tgh-booking-form-box" v-show="formBook">
        <div class="tgh-booking-form">
          <h1>Book</h1>
          <div class="row">
            <div class="col-12 col-md-12">
              <div class="form-group">
                <label>Name</label>
                <input type="text" v-model="booking.name" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Phone</label>
                <input type="text" v-model="booking.phone" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Email</label>
                <input type="text" v-model="booking.email" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Check In</label>
                <input type="text" v-model="booking.check_in" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Check Out</label>
                <input type="text" v-model="booking.check_out" class="form-control">
              </div>
            </div>
            <!-- <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Date of Birth</label>
                <input type="text" v-model="booking.dob" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Nationality</label>
                <input type="text" v-model="booking.nationality" class="form-control">
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="form-group">
                <label>Occupation</label>
                <input type="text" v-model="booking.occupation" class="form-control">
              </div>
            </div> -->
            <div class="col-12 col-md-12">
              <div class="form-group">
                <label>Request</label>
                <textarea class="form-control" v-model="booking.inquiry"></textarea>
              </div>
            </div>
            <div class="col-12">
              <p>*for any further information please contact us at +62812 9563 9046</p>
            </div>
            <div class="col-12 text-right mt-5">
              <button class="btn btn-default" type="button" @click="toglBook()">Cancel</button>
              <button class="btn btn-primary" type="button" @click="book()">Book</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="custom-classes-transition"
    enter-active-class="animated flipInX"
    leave-active-class="animated flipOutX">
      <div class="tgh-booking-thanks" v-show="successBook">
        <h1>Thank You</h1>
        <h6>We will contact you soon.</h6>
      </div>
    </transition>
    <AddressNav></AddressNav>
  </div>
</template>

<script>
import {apiUrl} from '../config'
import axios from 'axios'
import AddressNav from '@/components/AddressNav.vue'
import TitlePage from '@/components/TitlePage.vue'
export default {
  name: 'Booking',
  components: {
    AddressNav,
    TitlePage
  },
  data() {
    return {
      summary : [],
      booking : {
        name : null,
        dob : null,
        nationality : null,
        occupation : null,
        phone : null,
        email : null,
        inquiry : null
      },
      dailybook : null,
      successBook : false,
      formBook : false
    }
  },
  methods: {
    getSummary() {
      let vm = this
      let url = apiUrl+'/home/summary'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.summary = response.data.data.booking
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    },
    getLink() {
      let vm = this
      let url = apiUrl+'/home/dailybook'
      axios.get(
          url
      )
      .then(response => {
          if(response.data.status){
              vm.dailybook = response.data.data.content
          }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    },
    toglBook() {
      console.log(this.formBook)
      if(this.formBook){
        this.formBook = false
      } else {
        this.formBook = true
      }
    },
    book() {
      let vm = this
      let url = apiUrl+'/home/booking'
      let data = this.booking
      axios.post(
          url,
          data
      )
      .then(response => {
        if(response.status){
          this.formBook = false
          setTimeout(function(){
            vm.successBook = true
            setTimeout(function(){vm.successBook = false },3000)
          },500)
          this.clearForm()
        }
      })
      .catch(e => {
          console.log('Internal server error')
      })
    },
    clearForm() {
      this.booking = {
        name : null,
        dob : null,
        nationality : null,
        occupation : null,
        email : null,
        phone : null,
        inquiry : null
      }
    }
  },
  mounted(){
    this.getSummary()
    this.getLink()
  }
}
</script>
